import { render, staticRenderFns } from "./GradingSettingDetail.vue?vue&type=template&id=5665e83d"
import script from "../../controllers/grading_setting/grading-setting-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading_setting/grading-setting-detail.js?vue&type=script&lang=js&external"
import style0 from "./GradingSettingDetail.vue?vue&type=style&index=0&id=5665e83d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports